import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { UserService } from '@core/services/user.service';
import { InscriptionChangeRequestsService } from '../services/inscription-change-requests.service';
import { MenuItem } from 'primeng/api';
import { Observable, combineLatest, map } from 'rxjs';
import { AppMenuitemComponent } from './app.menuitem.component';

@Component({
  selector: 'gt-admin-menu',
  standalone: true,
  templateUrl: './app.menu.component.html',
  imports: [CommonModule, AppMenuitemComponent],
})
export class AppMenuComponent {
  isAdmin$ = this.usersService.isAdmin$;
  isEmployee$ = this.usersService.isEmployee$;
  isBooking$ = this.usersService.isBooking$;
  isMedia$ = this.usersService.isMedia$;
  /** Solicitudes de cambio que esperan a que alguien las atienda. */
  pendingChangeRequests$ = this.changeRequestsService.pendingCount$;

  menuItems$: Observable<MenuItem[]> = combineLatest([
    this.isAdmin$,
    this.isEmployee$,
    this.isBooking$,
    this.isMedia$,
    this.pendingChangeRequests$,
  ]).pipe(
    map(([isAdmin, isEmployee, isBooking, isMedia, pendingChangeRequests]) => [
      {
        label: 'Home',
        items: [{ label: 'Inicio', icon: 'pi pi-fw pi-home', routerLink: ['home'] }],
        visible: isAdmin || isEmployee,
      },
      {
        label: 'Media',
        items: [{ label: 'Galerías', icon: 'pi pi-fw pi-images', routerLink: ['galleries'] }],
        visible: isAdmin || isMedia || isEmployee,
      },
      {
        label: 'Usuarios',
        items: [{ label: 'Usuarios', icon: 'pi pi-fw pi-users', routerLink: ['users'], visible: isAdmin }],
        visible: isAdmin,
      },
      {
        label: 'Logística Organización',
        items: [
          {
            label: 'Personal Organización',
            icon: 'pi pi-fw pi-id-card',
            routerLink: ['organization-users'],
            visible: isAdmin || isEmployee || isBooking,
          },
          {
            label: 'Habitaciones',
            icon: 'pi pi-fw pi-objects-column',
            routerLink: ['rooming-list'],
            visible: isAdmin || isEmployee || isBooking,
          },
        ],
        visible: isAdmin || isEmployee || isBooking,
      },
      {
        label: 'Inscripciones',
        items: [
          { label: 'Inscritos', icon: 'pi pi-fw pi-users', routerLink: ['inscriptions'] },
          {
            label: 'Solicitudes de cambio',
            icon: 'pi pi-fw pi-pencil',
            routerLink: ['inscriptions', 'change-requests'],
            badge: pendingChangeRequests ? `${pendingChangeRequests}` : undefined,
          },
          { label: 'Mensajes', icon: 'pi pi-fw pi-send', routerLink: ['messages'] },
          { label: 'Emails', icon: 'pi pi-fw pi-at', routerLink: ['sended-emails'] },
          { label: 'Respuestas Formularios', icon: 'pi pi-fw pi-reply', routerLink: ['submissions'] },
        ],
        visible: isAdmin || isEmployee,
      },
      {
        label: 'Configuraciones',
        items: [
          {
            label: 'Guías',
            icon: 'pi pi-fw pi-book',
            items: [
              { label: 'Secciones', icon: 'pi pi-fw pi-tags', routerLink: ['guides/categories'] },
              { label: 'Lista de Guías', icon: 'pi pi-fw pi-list', routerLink: ['guides/list'] },
            ],
          },
          {
            label: 'Foro Comunidad',
            icon: 'pi pi-fw pi-comments',
            items: [
              { label: 'Categorías', icon: 'pi pi-fw pi-tags', routerLink: ['community-forum/categories'] },
              { label: 'Publicaciones', icon: 'pi pi-fw pi-list', routerLink: ['community-forum/list'] },
            ],
          },
          {
            label: 'AI Chat Prompts',
            icon: 'pi pi-fw pi-microchip-ai',
            routerLink: ['ai-chat-prompts'],
          },
          { label: 'Categorías', icon: 'pi pi-fw pi-users', routerLink: ['categories'] },
          { label: 'Ediciones', icon: 'pi pi-fw pi-flag', routerLink: ['editions'] },
          {
            label: 'Emails automáticos',
            icon: 'pi pi-fw pi-envelope',
            routerLink: ['scheduled-emails'],
          },
          {
            label: 'Formularios',
            icon: 'pi pi-fw pi-align-justify',
            routerLink: ['forms'],
          },
          {
            label: 'Vehículos',
            icon: 'pi pi-fw pi-car',
            routerLink: ['vehicles'],
          },
          {
            label: 'Tracks & Waypoints Mapa',
            icon: 'pi pi-fw pi-map-marker',
            routerLink: ['map-waypoints'],
          },
        ],
        visible: isAdmin || isEmployee,
      },
      {
        label: 'Reservas',
        items: [
          { label: 'Actividad', icon: 'pi pi-fw pi-chart-bar', routerLink: ['booking-activity'] },
          { label: 'Hoteles', icon: 'pi pi-fw pi-building', routerLink: ['reservation-items/hotels'] },
          { label: 'Ferrys', icon: 'pi pi-fw pi-arrow-right-arrow-left', routerLink: ['reservation-items/ferrys'] },
          {
            label: 'Conceptos Personalizados',
            icon: 'pi pi-fw pi-tag',
            routerLink: ['reservation-items/custom-concepts'],
          },
          { label: 'Asignación Hoteles / Ferrys', icon: 'pi pi-fw pi-check', routerLink: ['reservation-items'] },
          { label: 'Reservas', icon: 'pi pi-fw pi-book', routerLink: ['bookings'] },
          { label: 'Inscritos', icon: 'pi pi-fw pi-users', routerLink: ['booking-inscriptions'] },
          { label: 'Acceso por equipo', icon: 'pi pi-fw pi-lock', routerLink: ['booking-team-access'] },
          { label: 'Instrucciones y textos legales', icon: 'pi pi-fw pi-align-justify', routerLink: ['legal-texts'] },
        ],
        visible: isAdmin || isBooking,
      },
    ]),
  );
  constructor(
    public usersService: UserService,
    private changeRequestsService: InscriptionChangeRequestsService,
  ) {}
}
